'use client';

import { c as _c } from "react/compiler-runtime";
import { HeaderCompact } from 'design-system/client';
import { useTranslations } from 'next-intl';
import TextLink from '@/components/TextLink';
function Header() {
  const $ = _c(7);
  const t = useTranslations("nextjs.header");
  let t0;
  if ($[0] !== t) {
    t0 = t("betterplace_logo_alt_text");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("claim");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <HeaderCompact Link={TextLink} text={{
      homePageUrl: process.env.NEXT_PUBLIC_BETTERPLACE_URL,
      logoAlt: t0,
      claim: t1
    }} />;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export default Header;